import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { useScrollReveal } from '../hooks/useScrollReveal';

const faqs = [
  {
    q: 'Qual a diferença entre simpatectomia e outros tratamentos?',
    a: 'Desodorante, botox, loção, medicamentos anticolinérgicos — todos são paliativos e precisam ser repetidos. Simpatectomia é definitiva: uma cirurgia, resolvido para a vida.',
  },
  {
    q: 'É perigoso? Cirurgia no tórax assusta.',
    a: 'Entendo o medo. Mas a simpatectomia torácica endoscópica é um procedimento de baixo risco, realizado há mais de 40 anos, com taxa de complicações menor que 2%. O acesso é minimamente invasivo — duas pequenas incisões e visualização por câmera de alta definição. Complicações sérias são raras. Você vai conversar tudo isso comigo antes de decidir.',
  },
  {
    q: 'Quanto tempo de afastamento do trabalho?',
    a: 'A maioria volta em 3-5 dias para trabalho administrativo. Se o trabalho envolve esforço físico intenso, o afastamento é de 15 dias.',
  },
  {
    q: 'Posso voltar ao esporte / academia?',
    a: 'Sim. Exercício leve: após 2-3 semanas. Exercício intenso e academia: sem restrições após 6 semanas.',
  },
  {
    q: 'Meu convênio cobre?',
    a: 'A maioria dos convênios tem cobertura — porque é tratamento médico, não cirurgia estética. Se não cobrir, conversamos sobre opções facilitadas para pagamento particular.',
  },
  {
    q: 'Quanto custa?',
    a: 'Entre em contato e minha equipe vai te passar um orçamento personalizado, levando em conta seu convênio e as particularidades do seu caso.',
  },
  {
    q: 'Sempre funciona?',
    a: 'A taxa de satisfação com a cirurgia pode chegar a 97%. Em alguns casos (cerca de 30%) pode acontecer algum grau de sudorese compensatória, quando o suor aparece em outro local. Mas a intensidade costuma ser bem menor, com baixíssima taxa de arrependimento. Na consulta, alinhamos expectativas com realidade.',
  },
  {
    q: 'Conheço alguém que fez e não recomenda.',
    a: 'Cada corpo é diferente. Alguns podem experimentar sudorese compensatória — efeito colateral controlável. Meu papel na consulta é alinhar expectativas com realidade. Não opero quem não deve ser operado.',
  },
];

export default function FAQSection() {
  const [ref, isVisible] = useScrollReveal();
  return (
    <section id="faq" ref={ref} className={`py-24 md:py-32 bg-white transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">

        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-flex items-center bg-[#00897B]/10 text-[#00897B] rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
            Tire Suas Dúvidas
          </div>
          <h2 className="font-poppins font-bold text-3xl sm:text-4xl text-[#212121] mb-4 leading-tight">
            Dúvidas Frequentes —<br />Respondidas Com Honestidade
          </h2>
          <p className="text-[#212121]/65 text-base">
            Perguntas reais de pacientes reais. Respondidas sem rodeios.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="border border-gray-100 rounded-xl bg-[#F5F5F5] px-6 overflow-hidden"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="font-poppins font-semibold text-[#212121] text-sm md:text-base text-left hover:no-underline hover:text-[#0D47A1] py-5 [&[data-state=open]]:text-[#0D47A1] transition-colors"
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#212121]/70 text-sm md:text-base leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

      </div>
    </section>
  );
}
